import { VButton } from '@vrzl/ui';
import { Pencil } from 'lucide-react';
import { useState } from 'react';

import { useMe } from '@/domains/sync/api/me';

import type { OverviewBlock } from '../api/types';

import type { CriterionOption } from './criterionPicker';
import { EditOverviewDialog } from './editOverviewDialog';

type EditOverviewButtonProps = {
  blocks: OverviewBlock[];
  options: readonly CriterionOption[];
  perspective: { id: string; name: string };
  disabled: boolean;
};

/**
 * Alleen voor beheerders (zelfde check als retryExtractionButton.tsx); de backend dwingt
 * dit ook af met requireAdmin. De modal wordt pas gemount bij openen, zodat hij elke
 * keer met een verse kopie van de configuratie start.
 */
export function EditOverviewButton({ blocks, options, perspective, disabled }: EditOverviewButtonProps) {
  const { data: me } = useMe();
  const [open, setOpen] = useState(false);

  if (!me?.isAdmin) return null;

  return (
    <>
      <VButton
        type="button"
        variant="outline"
        icon={Pencil}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Bewerken
      </VButton>
      {open && (
        <EditOverviewDialog
          initialBlocks={blocks}
          options={options}
          perspective={perspective}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
